<span *ngFor="let displayValue of displayValues; index as index">
    <input type="radio" name="{{getHtmlName()}}" id="{{getHtmlName()+'_'+index}}"
           value="{{displayValue.Valeur}}" [checked]="isChecked(displayValue.ValeurID)">
    <label for="{{getHtmlName()+'_'+index}}" (click)="checkRadio(displayValue.ValeurID)">{{displayValue.Valeur}}</label>
</span>
